// Contains the environment config for all environments.
// The configuration.service will choose the correct config object
// based on the current environment which is set during release by
// replacing the token in assets/env.json.  The default is set to local

export const environment = {
  production: false
};
